<article class="project-details-stages-transition">
        <!-- TODO set up an empty stage because there is no origin stage -->
    <div *ngIf="origin==null"class="project-stage project-stage-none"><div class="project-stage-none-content"><h4><em>N/A</em></h4></div> </div>
    <div *ngIf="origin!=null" class="project-stage project-stage-default" [style.background-color]="origin.color">
      <div class="project-stage-first">
        <h4 class="ng-binding"> <em>{{origin.name}}</em> <strong></strong></h4>
        <span class="project-stage-arrow-top"></span>
        <span class="project-stage-arrow-bottom"></span>
      </div>
    </div>
    <div class="project-stage project-stage-default" [style.background-color]="status.color">
        <div class="project-stage-two">
          <h4 class="ng-binding"> <em>{{status.name}}</em> <strong></strong></h4>
          <span class="project-stage-arrow-top"></span>
          <span class="project-stage-arrow-bottom"></span>
        </div>
      </div>
  </article>
